<template>
  <div class="letteringList flexcenter">
    <div class="letteringListDialog flexcenter">
      <div class="modal-close" @click="close"></div>
      <div class="letteringListInner">
        <h3>学習言語の文字と発音</h3>
        <div class="modal-inner">
          <div class="letters">
            <div class="flexbox">
              <div v-for="(item, index) in characters" 
                   class="letter"
                   :class="{ active: selectedLetter == index}"
                   :style="{fontSize: letterFontSize}"
                   @click="selectCharacter(index)"><span>{{item.text}}</span></div>
            </div>
          </div>
          <div class="words">
            <div class="section-container">
              <div class="section-title"><button class="icon-voice" @click="characterAudioPlay(characterSound)" v-show="characterText != ''"></button><h4 class="textgreen2" :style="{fontSize: titleFontSize}">{{ characterText }}</h4></div>
              <div class="section-content">
                <div class="section-group" v-for="(phoneticItem, phoneticIndex) in phoneticList">
                  <template >
                    <div class="word" v-for="(childItem, childIndex) in phoneticItem" :style="{fontSize: wordFontSize}">
                    <button class="icon-voice" @click="characterAudioPlay(childItem.sound)"></button>
                    <span class="word-group">
                      <template v-for="(scriptItem, scriptIndex) in childItem.scripts">
                      <span class="word-group-item" v-html="getDispText(scriptItem)"></span>
                      </template>
                    </span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixin/common'
import audio from '@/mixin/audio'
import resource from '@/mixin/resource'
import * as constants from '@/mixin/constants'

export default {
  name: 'languageLetter',
  mixins: [
    common,
    audio,
    resource
  ],
  props: {
    jsonData: Object,
    productInfo: Object
  },
  data: function() {
    return {
      characters: [],   // 文字データ配列
      characterText: '', // 文字ラベル
      characterSound: '', // 文字音声ファイルパス
      currentCharacterIndex: -1, // 現在の選択文字配列番号
      phoneticList: [],  // 単語リスト
      groupList: [],     // グループ
      letterFontSize: '', // 文字フォントサイズ
      wordFontSize: '',   // 単語フォントサイズ
      maxWordTextLength: 0, // 単語最大文字数
      titleFontSize: '',  // セクションタイトルフォントサイズ
      isPc: true,         // PCフラグ
    }
  },
  computed: {
    /**
     * 選択中の文字
     * @returns {default.computed.currentCharacterIndex}
     */
    selectedLetter: function() {
      return this.currentCharacterIndex;
    },
    /**
     * スクリプトID
     * @returns {default.computed.$store.getters.scriptType}
     */
    scriptType: function () {
      return this.$store.getters.scriptType;
    },
    /**
     * 表示形式
     *
     * @return {String} 表示形式
     */
    displayMode: function() {
      return this.$store.getters.displayMode;
    },
  },
  methods: {
    /**
     * 初期処理
     */
    initLanguageLetter: function () {
      var self = this;

      this.isPc = this.isEnvironmentPc()
      // 文字フォントサイズ
      this.letterFontSize = this.getLetterFontSize()
      // 単語フォントサイズ
      this.wordFontSize = this.getWordFontSize(1)
      // セクションタイトルフォントサイズ
      this.titleFontSize = this.getTitleFontSize()

      // Alphabetリソースロード済みか確認
      if (this.jsonData.characters) {
        this.characters = this.jsonData.characters;
        this.selectCharacter(0);
        return;
      }

      // 文字データJSON取得
      this.loadAlphabetResource(this.jsonData.levels[0].alphabetResourceID).then(
        function(data){
          // 取得成功
          self.jsonData.characters = data.characters;
          self.characters = self.jsonData.characters;
          self.selectCharacter(0);
        }, function(err){
          // 取得失敗時の処理
          self.log(err);
        });
    },
    /**
     * 本画面を閉じる
     */
    close: function () {
      if (this.locked) {
        return
      }
      this.$emit('close')
    },
    /**
     * 文字を選択
     * @param int index 選択した文字の要素番号
     */
    selectCharacter: async function(index) {
      // 選択中の文字と同じ場合はスキップ
      if (index == this.currentCharacterIndex) return;
      this.currentCharacterIndex = index;
      await this.updateCharacterResources(this.characters[this.currentCharacterIndex]);
      if (this.characters[this.currentCharacterIndex]) {
        // トップ文字
        this.characterText = this.characters[this.currentCharacterIndex].text;
        this.characterSound = this.characters[this.currentCharacterIndex].sound;
        this.setPhoneticList(this.currentCharacterIndex);
      }
    },
    /**
     * 単語一覧を取得
     * @param {type} index
     */
    setPhoneticList: function(index) {
      if (this.characters[index].phoneticGroups) {
        // 最大文字数リセット
        this.maxWordTextLength = 0
        // 単語一覧取得
        this.phoneticList = this.characters[index].phoneticGroups;
        this.setJpnPhoneticList();
      } else {
        this.log(this.$options.name+" phoneticGroups Not Found Index::"+this.currentCharacterIndex);
      }
    },
    /**
     *  phoneticListを日本語表示用に設定
     */
    setJpnPhoneticList: function() {
      // 日本語以外は処理終了
      if (this.productInfo.language != constants.LANGUAGE_CODE_JAJP) {
        return;
      }
      
      var tempPhoneticList = this.phoneticList;
      var blankScriptObj = {
        color: null,
        scriptID: null,
        text: "",
        underline: null,
      };
      
      for(var i = 0; i < tempPhoneticList.length; i++) {
        for(var j = 0; j < tempPhoneticList[i].length; j++) {
          
          if(this.phoneticList[i][j].scripts.length >= 3) {
            continue;
          }
          
          // ひらがな／かたかな／ローマ字の要素が存在するかを確認し、存在しない場合は空の要素を追加する。
          if(!this.phoneticList[i][j].scripts.find(function (scripts) { if(scripts.scriptID == constants.TEXT_SCRIPTID_HIRAGANA) return true; })) {
            this.phoneticList[i][j].scripts.splice(0, 0, blankScriptObj);
          }
          if(!this.phoneticList[i][j].scripts.find(function (scripts) { if(scripts.scriptID == constants.TEXT_SCRIPTID_KATAKANA) return true; })) {
            this.phoneticList[i][j].scripts.splice(1, 0, blankScriptObj);
          }
          if(!this.phoneticList[i][j].scripts.find(function (scripts) { if(scripts.scriptID == constants.TEXT_SCRIPTID_ROMAJI) return true; })) {
            this.phoneticList[i][j].scripts.splice(1, 0, blankScriptObj);
          }
        }
      }
    },
    /**
     * 音声再生
     * @param string audioPath オーディオファイルパス
     */
  	characterAudioPlay: function(audioPath) {
        // 音声再生
        this.audioPlay(audioPath);
    },
    /**
     * 画面表示文字列を取得
     */
    getDispText: function(scriptItem) {
      var newText = ''
      
      // 文字数によりフォントサイズを変更
      if (this.maxWordTextLength < scriptItem.text.length) {
        this.maxWordTextLength = scriptItem.text.length
        this.wordFontSize = this.getWordFontSize(this.maxWordTextLength)
      }
      
      var splitTextList = scriptItem.text.split('')
      // COLOR
      var colorStartIndex = 0;
      var colorLength = 0;
      var colorEndIndex = 0;
      var color = false;
      if (scriptItem.color) {
        colorStartIndex = scriptItem.color.startIndex?scriptItem.color.startIndex:0;
        colorLength = scriptItem.color.length?scriptItem.color.length:0;
        colorEndIndex = colorStartIndex + colorLength - 1;
        if (colorEndIndex >= 0)
          color = scriptItem.color.value?scriptItem.color.value.replace('0x', '#'):'#000';
      }
      // UNDERLINE
      var underlineStartIndex = 0;
      var underlineLength = 0;
      var underEndIndex = 0;
      var underline = false;
      if (scriptItem.underline) {
        underlineStartIndex = scriptItem.underline.startIndex?scriptItem.underline.startIndex:0;
        underlineLength = scriptItem.underline.length?scriptItem.underline.length:0;
        underEndIndex = underlineStartIndex + underlineLength - 1;
        if (underEndIndex >= 0)
          underline = true;
      }
      var newText = '';
      for (var i = 0; i < splitTextList.length; i++) {
        var preText = splitTextList[i]
        var styles = [];
        if (color && (i >= colorStartIndex && i <=colorEndIndex)) {
          // 色追加
          styles.push('color:' + color + ';');
        }
        if (styles.length > 0) {
          // スタイル追加
          preText = '<span style="' + styles.join('') +'">' + preText + '</span>';
        }
        if (underline && underlineStartIndex == i) {
          preText = '<span style="dispaly:inline-block; text-decoration:underline;">' + preText
        }
        if (underline && underEndIndex == i) {
          preText += '</span>'
        }
        newText += preText
      }
      return newText;
    },
    /**
     * 単語フォントサイズ
     * @returns String CSS font-size
     */
    getWordFontSize: function(textLength) {
      var fontSize = this.isPc?'3.6rem':'2.4rem'
      switch (this.productInfo.language) {
        case constants.LANGUAGE_CODE_DEDE:
        case constants.LANGUAGE_CODE_GAIE:
        case constants.LANGUAGE_CODE_SVSE:
        case constants.LANGUAGE_CODE_PTBR:
          // ドイツ語／アイルランド語／スウェーデン語／ポルトガル語
          if (textLength >= 12) {
            fontSize = this.isPc?'3.2rem':'2.4rem'
          }
          break;
        case constants.LANGUAGE_CODE_NLNL:
          // オランダ語
          if (textLength >= 13) {
            fontSize = this.isPc?'3.2rem':'2.4rem'
          }
          break;
        case constants.LANGUAGE_CODE_RURU:
          // ロシア語
          if (textLength >= 11) {
            fontSize = this.isPc?'3.0rem':'2.4rem'
          }
          break;
        case constants.LANGUAGE_CODE_ZHCV:
          //中国語
          if (textLength >= 12) {
            fontSize = this.isPc?'2.4rem':'1.2rem'
          } else {
            fontSize = this.isPc?'3.0rem':'1.5rem'
          }
          break;
        case constants.LANGUAGE_CODE_JAJP:
          // 日本語
          if (textLength >= 14) {
            fontSize = this.isPc?'1.5rem':'0.75rem'
          } else if (textLength >= 9) {
            fontSize = this.isPc?'2.0rem':'1.0rem'
          } else if (textLength >= 6) {
            fontSize = this.isPc?'2.6rem':'1.3rem'
          }
        default:
          break;
      }
      return fontSize
    }, 
    /**
     * 文字フォントサイズ
     * @returns String フォントサイズ
     */
    getLetterFontSize: function() {
      var fontSize = '3rem'
      switch (this.productInfo.language) {
        case constants.LANGUAGE_CODE_ZHCV:
          //中国語
          fontSize = this.isPc?'1.8rem':'1.65rem'
          break;
        case constants.LANGUAGE_CODE_JAJP:
          // 日本語
          fontSize = this.isPc?'1rem':'0.9rem'
          break;
        case constants.LANGUAGE_CODE_TLPH:
        case constants.LANGUAGE_CODE_ES419:
        case constants.LANGUAGE_CODE_ELGR:
          // フィリピン語／スペイン語（ラテンアメリカ）／ギリシャ語
          fontSize = this.isPc?'2.2rem':'2.1rem'
        default:
          break;
      }
      return fontSize
    },
    /**
     * タイトルフォントサイズ
     * @returns String フォントサイズ
     */
    getTitleFontSize: function() {
      var fontSize = this.isPc?'6rem':'4.2rem'
      switch (this.productInfo.language) {
        case constants.LANGUAGE_CODE_JAJP:
          // 日本語
          fontSize = this.isPc?'4.8rem':'4.2rem'
          break;
        default:
          break;
      }
      return fontSize
    }
  },
  created: function() {
    this.log(this.$options.name+" Created!!");
  },
  mounted: function() {
    this.log(this.$options.name+" Mounted!!");
    this.setBodyStylePosition(true);
    this.initLanguageLetter();
  },
  beforeDestroy: function() {
    this.log(this.$options.name+" BeforeDestroy!!");
    this.setBodyStylePosition(false);
  }
}
</script>

<style scoped lang="scss">
body.propPc{
  &.chn,
  &.jpn{
    .letteringList{
      .modal-inner{
        .words{
          .section-content{
            .section-group{
              .word {
                padding-right: 0;
                width: 100%;
              }
            }
          }
        }
      }
    }
    .word-group{
      display: inline-block;
      margin-right: 0;
      width: 515px;
      &-item{
        display: inline-block;
        width: 33.3333%;
        vertical-align: top;
      } 
    }
  }
}
body.propSp{
  &.chn,
  &.jpn{
    .letteringList{
      .modal-inner{
        .words{
          .section-content{
            .section-group{
              padding: 5px 0;
              .word {
                .icon-voice{
                  margin-right: 1%;
                  width: 10%;
                  max-width: 35px;
                  background-size: contain;
                }
              }
            }
          }
        }
      }
    }
    .word-group{
      display: inline-block;
      margin-right: 0;
      width: 86%;
      &-item{
        display: inline-block;
        width: 33.3332%;
        vertical-align: top;
      } 
    }
  }
}
</style>



// WEBPACK FOOTER //
// LanguageLetter.vue?5d8c2dae